import {OrderSheetPageSet, OrderSheetPageSetType} from '@web/core/constants'
import getApi, {createWrapper, getBaseUrl} from '@web/helpers/api'

import {BankEasyPaysReloadResponse, CardEasyPaysReloadResponse} from './interfaces'

const PointApiUrlInfo = {
    [OrderSheetPageSet.MALL]: {
        /** 계좌 간편결제 정보 재조회 */
        bankEasyPaysReload: '/orderSheet/mall/bankEasyPays',
        /** 카드 간편결제 정보 재조회 */
        cardEasyPaysReload: '/orderSheet/mall/cardEasyPays',
    },
    [OrderSheetPageSet.EASYBOOKING]: {
        /** 계좌 간편결제 정보 재조회 */
        bankEasyPaysReload: '/orderSheet/easyBooking/bankEasyPays',
        /** 카드 간편결제 정보 재조회 */
        cardEasyPaysReload: '/orderSheet/easyBooking/cardEasyPays',
    },
    [OrderSheetPageSet.SELLER]: {
        /** 계좌 간편결제 정보 재조회 */
        bankEasyPaysReload: '/orderSheet/seller/bankEasyPays',
        /** 카드 간편결제 정보 재조회 */
        cardEasyPaysReload: '/orderSheet/seller/cardEasyPays',
    },
    [OrderSheetPageSet.FAMILY_PAY]: {
        /** 계좌 간편결제 정보 재조회 */
        bankEasyPaysReload: '/orderSheet/familyPay/bankEasyPays',
        /** 카드 간편결제 정보 재조회 */
        cardEasyPaysReload: '/orderSheet/familyPay/cardEasyPays',
    },
    // 클레임 비용결제는 간편결제를 지원하지 않습니다.
    [OrderSheetPageSet.CLAIM]: {
        /** 계좌 간편결제 정보 재조회 */
        bankEasyPaysReload: '',
        /** 카드 간편결제 정보 재조회 */
        cardEasyPaysReload: '',
    },
}

/** 간편계좌 목록 조회 */
async function getBankEasyPays({pageSet, orderSheetId}: {pageSet: OrderSheetPageSetType; orderSheetId?: string}) {
    const url = PointApiUrlInfo[pageSet].bankEasyPaysReload
    const baseUrl = getBaseUrl(pageSet)
    const api = getApi(baseUrl)
    return createWrapper<BankEasyPaysReloadResponse>(
        api.get(url, {
            params: {
                ...(pageSet === OrderSheetPageSet.FAMILY_PAY ? {orderNo: orderSheetId} : {}),
            },
        }),
    )
}

/** 간편카드 목록 조회 */
async function getCardEasyPays({pageSet, orderSheetId}: {pageSet: OrderSheetPageSetType; orderSheetId?: string}) {
    const url = PointApiUrlInfo[pageSet].cardEasyPaysReload
    const baseUrl = getBaseUrl(pageSet)
    const api = getApi(baseUrl)
    return createWrapper<CardEasyPaysReloadResponse>(
        api.get(url, {
            params: {
                ...(pageSet === OrderSheetPageSet.FAMILY_PAY ? {orderNo: orderSheetId} : {}),
            },
        }),
    )
}

export default {
    getBankEasyPays,
    getCardEasyPays,
}
